var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyFilterEntity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration-Empty-State-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 62"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 32.049,
    cy: 41.5148,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 35",
    cx: 180.976,
    cy: 59.1769,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 202.456,
    cy: 68.2472,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 37",
    cx: 200.069,
    cy: 98.3175,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    cx: 9.61489,
    cy: 69.6789,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 61.1662,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 17",
    cx: 92.6701,
    cy: 192.829,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 149.95,
    cy: 179.943,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    opacity: 0.15,
    cx: 128.47,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    opacity: 0.3,
    cx: 109.854,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    opacity: 0.3,
    cx: 174.293,
    cy: 166.814,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 38",
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 39",
    opacity: 0.15,
    cx: 180.26,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 40",
    opacity: 0.3,
    cx: 184.079,
    cy: 93.5449,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 41",
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3164,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 42",
    opacity: 0.15,
    cx: 186.466,
    cy: 40.7988,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    opacity: 0.15,
    cx: 73.8159,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 27",
    opacity: 0.15,
    cx: 13.4331,
    cy: 147.723,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.924,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    opacity: 0.15,
    cx: 2.69333,
    cy: 94.5,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    opacity: 0.3,
    cx: 21.5478,
    cy: 64.666,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 31",
    opacity: 0.15,
    cx: 25.3667,
    cy: 22.4218,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    opacity: 0.3,
    cx: 61.8823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8086,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 134.436,
    cy: 18.8418,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 19",
    d: "M170.475 150.348C169.421 150.348 168.566 149.493 168.566 148.439C168.566 147.384 169.421 146.529 170.475 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 14",
    d: "M6.51221 117.651C7.5667 117.651 8.42153 116.796 8.42153 115.741C8.42153 114.687 7.5667 113.832 6.51221 113.832",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 43",
    d: "M74.5317 22.4222C75.5862 22.4222 76.4411 21.5673 76.4411 20.5128C76.4411 19.4583 75.5862 18.6035 74.5317 18.6035",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 44",
    d: "M120.833 15.7399C119.779 15.7399 118.924 16.5948 118.924 17.6493C118.924 18.7038 119.779 19.5586 120.833 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M10.3306 166.934H16.2972M26.3211 155.836V157.387M38.0157 166.934H39.5671M26.3211 176.48V178.27M26.3211 180.657V186.982M21.9058 166.934C24.8892 166.934 26.4405 162.638 26.4405 162.638C26.4405 162.638 26.9178 166.934 30.7365 166.934C29.0181 166.934 26.5598 168.485 26.3211 171.588C26.3211 171.588 26.0432 169.048 25.1278 168.127C24.3635 167.359 21.9058 166.934 21.9058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M188.709 28.0606L182.742 28.0606M172.599 43.8125L172.718 37.6072M161.024 28.0606L159.472 28.0606M172.599 18.7526L172.599 6.58071M177.134 28.0606C174.15 28.0606 172.599 32.3565 172.599 32.3565C172.599 32.3565 172.122 28.0606 168.303 28.0606C170.021 28.0606 172.48 26.5092 172.718 23.4066C172.718 23.4066 172.996 25.9467 173.912 26.8672C174.676 27.6358 177.134 28.0606 177.134 28.0606Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.3076,
    cy: 95.3472,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.566 95.3472C166.566 132.155 136.462 162.009 99.3076 162.009C62.1536 162.009 32.0493 132.155 32.0493 95.3472C32.0493 58.5392 62.1536 28.6855 99.3076 28.6855C136.462 28.6855 166.566 58.5392 166.566 95.3472Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M105.156 51.7109V61.1016H90.75V51.7109C90.75 51.5083 90.9145 51.3438 91.1172 51.3438H104.789C104.992 51.3438 105.156 51.5083 105.156 51.7109Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.8359 43.6016H74.1641C73.9614 43.6016 73.7969 43.4371 73.7969 43.2344V29.5625C73.7969 29.3598 73.9614 29.1953 74.1641 29.1953H87.8359C88.0386 29.1953 88.2031 29.3598 88.2031 29.5625V43.2344C88.2031 43.4371 88.0386 43.6016 87.8359 43.6016Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M115.18 38.4062H101.508C101.305 38.4062 101.141 38.2417 101.141 38.0391V24.3672C101.141 24.1645 101.305 24 101.508 24H115.18C115.382 24 115.547 24.1645 115.547 24.3672V38.0391C115.547 38.2417 115.382 38.4062 115.18 38.4062Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M55.8795 75L55.5 74.8899V66.2429C55.5 64.4757 56.9767 63 58.8517 63H131.148C133.023 63 134.5 64.4757 134.5 66.2429V74.8899L134.121 75H55.8795Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M99.8672 112.825C99.8672 100.763 108.944 90.782 120.625 89.35L132.844 75.0156H56.5L85.3025 108.806V148.837C85.3025 149.897 86.4554 150.554 87.3667 150.014L102.701 140.927C103.532 140.434 104.041 139.54 104.041 138.574V126.226C101.41 122.415 99.8672 117.797 99.8672 112.825Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M145.445 111.824C145.445 124.486 135.181 134.75 122.52 134.75C109.858 134.75 99.5938 124.486 99.5938 111.824C99.5938 99.1627 109.858 88.8984 122.52 88.8984C135.181 88.8984 145.445 99.1627 145.445 111.824Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 178",
    d: "M132.5 102L112.5 122",
    stroke: "#194590",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 179",
    d: "M112.5 102L132.5 122",
    stroke: "#194590",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M121.722 53.7464C121.722 53.7464 121.722 53.7464 121.722 53.7464M121.722 53.7464L121.722 53.7465L121.722 53.7464M121.722 53.7464L121.722 53.7464M121.722 53.7464L121.722 53.7464M121.617 53.6861L117.547 51.3361V46.6362L121.617 44.2863L125.688 46.6362V51.3361L121.617 53.6861ZM125.792 46.6966C125.792 46.6965 125.792 46.6964 125.792 46.6964L125.792 46.6965L125.792 46.6966ZM121.513 53.7465C121.513 53.7464 121.513 53.7463 121.513 53.7462L121.513 53.7464L121.513 53.7465Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M59.0078 54.2229V49.5229L63.078 47.173L67.1482 49.5229V54.2229L63.078 56.5728L59.0078 54.2229ZM62.9734 56.6332C62.9735 56.6331 62.9737 56.633 62.9738 56.633L62.9736 56.6331L62.9734 56.6332ZM63.1823 56.633C63.1824 56.6331 63.1826 56.6332 63.1827 56.6332L63.1825 56.6331L63.1823 56.633Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFilterEntity);
export default __webpack_public_path__ + "static/media/empty_filter_entity.1fa508b54154cd3d6a0c6173f528a0ac.svg";
export { ForwardRef as ReactComponent };